<template>
    <div class="site-search__no-results">
        <h2>No results Found</h2>

        <form class="search-form" method="get">
            <label class="search-form__label visually-hidden" for="SiteSearch">
                Search our site
            </label>

            <input
                type="text"
                id="SiteSearch"
                name="q"
                class="search-form__input"
                placeholder="Search our site"
                aria-label="Search our site"
                v-model="props.query"
                required />

            <button class="search-form__button"
                    @click.prevent="triggerSearch(props.query)"
                    type="submit"
                    aria-label="search"
                    enterkeyhint="search" >
                <span class="visually-hidden">Search</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                    <g clip-path="url(#clip0_1323_917)">
                        <path d="M0 6.49414C0 10.0748 2.91341 12.9883 6.49414 12.9883C7.91016 12.9883 9.20408 12.5326 10.2702 11.7676L14.2741 15.7796C14.4613 15.9668 14.7054 16.0563 14.9658 16.0563C15.5192 16.0563 15.9017 15.6413 15.9017 15.096C15.9017 14.8356 15.804 14.5996 15.6332 14.4288L11.6537 10.4248C12.4918 9.33433 12.9883 7.97526 12.9883 6.49414C12.9883 2.91341 10.0748 0 6.49414 0C2.91341 0 0 2.91341 0 6.49414ZM1.3916 6.49414C1.3916 3.67838 3.67838 1.3916 6.49414 1.3916C9.30992 1.3916 11.5967 3.67838 11.5967 6.49414C11.5967 9.30992 9.30992 11.5967 6.49414 11.5967C3.67838 11.5967 1.3916 9.30992 1.3916 6.49414Z" fill="black"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_1323_917">
                            <rect width="16.2028" height="16.0563" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
            </button>
        </form>
    </div>
</template>
<script setup>
import {getState} from "../services/stateful";

const props = defineProps({
    query: {
        type: String,
        required: true,
        default: '',
    }
});

const triggerSearch = getState('Search.Trigger');
</script>
